import React, { useContext, useState } from "react";
import type { NotificationInterface } from "types/notification";
import Image from "components/File/Image";
import { IntlContext } from "context";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { batchReadNotifications, deleteNotification } from "hooks/notification";
import { Link, useNavigate } from "react-router-dom";
import { NotificationContext } from "app/Notification/Context";
import { NotificationComponentType } from "app/Notification/Context/Context";
import roundNumber from "helpers/roundNumber";

const List: React.FC<{ notification: NotificationInterface }> = ({ notification }) => {
    const intl = useContext(IntlContext);
    const { refreshNotifications, setIsOpen, getNotificationComponentType } = useContext(NotificationContext);
    const [isHover, setIsHover] = useState<boolean>(false);
    const navigate = useNavigate();

    const handleReadNotification = async () => {
        await batchReadNotifications([notification.id]);
        refreshNotifications();
    };

    const handleDeleteNotification = async () => {
        await deleteNotification(notification.id);
        refreshNotifications();
    };

    const handleRedirectNotificationLink = async () => {
        if (notification.link) {
            setIsOpen(false);
            navigate(notification.link);
            await batchReadNotifications([notification.id]);
            refreshNotifications();
        }
    };

    return (
        <div
            className={`notification-item ${!notification.is_read ? "notification-item__unread" : ""}`}
            onMouseOver={() => setIsHover(true)}
            onMouseOut={() => setIsHover(false)}
        >
            {(getNotificationComponentType() === NotificationComponentType.PAGE || isHover) && (
                <>
                    {!notification.is_read && (
                        <Icon
                            icon={{ prefix: "fas", iconName: "check" }}
                            className="notification-item__read-icon"
                            title={intl.formatMessage('notification.read')}
                            onClick={() => handleReadNotification()}
                        />
                    )}
                    <Icon
                        icon={{ prefix: "fas", iconName: "times" }}
                        className="notification-item__delete-icon"
                        title={intl.formatMessage('notification.delete')}
                        onClick={() => handleDeleteNotification()}
                    />
                </>
            )}

            <div className="notification-item__image">
                {notification.data.picture_id ? (
                    <Image id={notification.data.picture_id} />
                ) : (
                    <img src="/images/logo/logo-twoghether-picto.svg" alt="" />
                )}
            </div>

            <div
                className={"notification-item__text " + (notification.link ? "notification-btn" : "")}
                onClick={() => handleRedirectNotificationLink()}
            >
                <div className="notification-item__title">
                    {intl.formatMessage(`notification.${notification.type}.title`, {
                        booking_category: Object.keys(notification.data).length > 0 && notification.data.booking_category ? intl.formatMessage(
                            "category." + notification.data.booking_category.toString().toLowerCase()
                        ) : "",
                        user_name: notification.data.user_name,
                        date: notification.data.date,
                        start_time: notification.data.start_time,
                        end_time: notification.data.end_time,
                    })}
                </div>
                <div className="notification-item__body">
                    {intl.formatMessage(`notification.${notification.type}`, {
                        booking_category: Object.keys(notification.data).length > 0 && notification.data.booking_category ? intl.formatMessage(
                            "category." + notification.data.booking_category.toString().toLowerCase()
                        ) : "",
                        user_name: notification.data.user_name,
                        date: notification.data.date,
                        start_time: notification.data.start_time,
                        end_time: notification.data.end_time,
                        percentage_limit_company: roundNumber(Number(notification?.data?.percentage_limit_company)),
                        location: notification.data.location,
                    })}
                </div>
                {notification.link && (
                    <div className="notification-item__link">
                        <Link to={notification.link} onClick={() => setIsOpen(false)}>
                            {intl.formatMessage(`notification.${notification.type}.link`, {
                                to: notification.link,
                            })}
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
};

export default List;
